import { render, staticRenderFns } from "./ResizeSizeInput.vue?vue&type=template&id=f4bb807a&scoped=true"
import script from "./ResizeSizeInput.vue?vue&type=script&lang=js"
export * from "./ResizeSizeInput.vue?vue&type=script&lang=js"
import style0 from "./ResizeSizeInput.vue?vue&type=style&index=0&id=f4bb807a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bb807a",
  null
  
)

export default component.exports